<template>
  <v-sheet
    :id="`${props.target}`"
    :color="props.color_background"
    :class="`
      pt-${props.pt ? props.pt : '0'} 
      pb-${props.pb ? props.pb : '0'}`">
    <v-container fluid v-if="props" class="container-padding">
      <v-row justify="center">
        <v-col cols="12" sm="12" md="6" lg="6" xl="6">
          <p
            v-if="props.text_col_1 && props.text_col_1[language]"
            class="py-5 ma-0"
            v-html="props.text_col_1[language]"></p>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="6" xl="6">
          <p
            v-if="props.text_col_2 && props.text_col_2[language]"
            class="py-5 ma-0"
            v-html="props.text_col_2[language]"></p>
        </v-col>
      </v-row>

      <!-- Edit dialog -->
      <v-dialog v-if="edit" persistent v-model="edit" fullscreen>
        <v-card>
          <v-card-title class="text-h5 black white--text">
            Edit Component
          </v-card-title>
          <v-card-text class="pt-5">
            <Core
              :editProps="editProps"
              @emitProps="setPreviewProps"
              @save="save"
              @cancel="cancel"
              name="Core" />
            <!-- Preview -->
            <h2 class="my-2 text-h4 black--text">Preview:</h2>
            <CompText2Cols
              v-if="previewProps"
              name="CompText2Cols"
              :props="previewProps" />
          </v-card-text>
          <v-divider></v-divider>
        </v-card>
      </v-dialog>
    </v-container>
  </v-sheet>
</template>

<script>
import { mapState } from "vuex";
import CompText2Cols from "./CompText2Cols";
import Core from "../editor/Core.vue";

export default {
  name: "CompText2Cols",
  props: ["props", "edit", "index", "componentId"],
  data() {
    return {
      editProps: {},
      previewProps: null,
    };
  },
  watch: {
    edit: function () {
      this.editProps.color_background = {};
      this.editProps.color_background.type = "color";
      this.editProps.color_background.name = "color_background";
      this.editProps.color_background.value =
        this.props.color_background ?? "#FFFFFF";

      this.editProps.target = this.props.target ?? "";
      this.editProps.pt = this.props.pt ?? 0;
      this.editProps.pb = this.props.pb ?? 0;

      this.editProps.text_col_1 = {};
      this.editProps.text_col_1.type = "text";
      this.editProps.text_col_1.name = "text_col_1";
      this.editProps.text_col_1.value = this.props.text_col_1 ?? {};

      this.editProps.text_col_2 = {};
      this.editProps.text_col_2.type = "text";
      this.editProps.text_col_2.name = "text_col_2";
      this.editProps.text_col_2.value = this.props.text_col_2 ?? {};
    },
  },
  computed: {
    ...mapState({
      language: state => {
        return state.language ?? "de";
      },
    }),
  },
  mounted() {
    setTimeout(() => {
      if (this.$route.query.target)
        this.$vuetify.goTo(`#${this.$route.query.target}`, {});
    }, 100);
  },
  methods: {
    save(previewProps) {
      this.previewProps = JSON.parse(JSON.stringify(previewProps));
      this.$emit("save", this.previewProps, this.index, this.componentId);
    },
    cancel() {
      this.$emit("cancel");
    },
    setPreviewProps(previewProps) {
      this.previewProps = JSON.parse(JSON.stringify(previewProps));
    },
  },
  components: {
    Core,
    CompText2Cols,
  },
};
</script>

<style></style>
